import Input from './Input';

export default function ComponentsOverrides(theme: any) {
  return Object.assign(Input(theme));
}
